var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonValuationEmailManager',{attrs:{"type":"pre","department":"rs","title":"Sales Pre Valuation Email Manager"}})}
var staticRenderFns = []

export { render, staticRenderFns }